import moment from 'moment';
import Constants from '../../../constants';

export interface ITransactionDetailsSessionStoreState{
    id: string;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment;
    courtId: number;
    courtName: string;
    price: string;
    type: string;
    typeAlias: string;
    status: string;
}

export class TransactionDetailsSessionDto implements ITransactionDetailsSessionStoreState{
    id: string;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment;
    courtId: number;
    courtName: string;
    price: string;
    type: string;
    typeAlias: string;
    status: string;

    constructor(dto?: any) {
        this.id = dto && dto.id ? dto.id : '';
        this.startDateTime = dto && dto.startDateTime ? moment(dto.startDateTime, Constants.DateTime.API_FORMAT): moment.min();
        this.endDateTime = dto && dto.endDateTime ? moment(dto.endDateTime, Constants.DateTime.API_FORMAT) : moment.min();
        this.courtId = dto && dto.courtId ? dto.courtId : 0;
        this.courtName = dto && dto.courtName ? dto.courtName : '';
        this.price = dto && dto.price ? dto.price : '';
        this.type = dto && dto.type ? dto.type : '';
        this.typeAlias = dto && dto.typeAlias ? dto.typeAlias : '';
        this.status = dto && dto.status ? dto.status : '';
    }
}
